import { create } from 'zustand';
import client from '@/api/client';

interface BillingState {
  balance: number;
  transactions: any[];
  loading: boolean;
  fetchBalance: () => Promise<void>;
  fetchTransactions: (page?: number) => Promise<void>;
}

export const useBillingStore = create<BillingState>((set) => ({
  balance: 0,
  transactions: [],
  loading: false,
  fetchBalance: async () => {
    set({ loading: true });
    try {
      const res = await client.get('/billing/balance');
      set({ balance: res.data.data.balance, loading: false });
    } catch {
      set({ loading: false });
    }
  },
  fetchTransactions: async (page = 1) => {
    try {
      const res = await client.get(`/billing/transactions?page=${page}&per_page=20`);
      set({ transactions: res.data.data.data });
    } catch {}
  },
}));
